import * as Sentry from '@sentry/browser'

import { APP_VERSION, USER_UUID } from 'app-constants'

import Environment from '../utils/environment'

export default function initializeSentryClient(env: Environment) {
  const isDev = env.get('buildEnv') === 'development'

  if (env.get('sentryClientLogging') === 'true' && APP_VERSION) {
    Sentry.init({
      dsn: env.get('sentryUrl'),
      environment: env.get('buildEnv'),
      debug: isDev,
      release: APP_VERSION,
    })

    if (window.sessionStorage.getItem(USER_UUID)) {
      Sentry.configureScope(scope => {
        scope.setUser({ id: window.sessionStorage.getItem(USER_UUID) })
      })
    }
  }
}
